import { ref } from 'firebase/storage';
import { UploadFileToStorage } from '../utils/firebase/helper';
import { FirebaseStorage } from '../utils/firebase/firebase';

export const uploadProfilePic = async (user, file) => {
  try {
    const blob = new Blob([file], {
      type: file.type,
    });
    const profileStorageRef = ref(
      FirebaseStorage,
      `profiles/${user?.uid}/${file.name}`
    );
    const uploadResult = await UploadFileToStorage(profileStorageRef, blob);
    if (!uploadResult?.status) {
      throw new Error('Error Uploading profile picture');
    }
    return uploadResult?.data;
  } catch (error) {
    console.error('Profile picture upload error:', error);
    throw error;
  }
};

export const updateGlobalUser = (setUser, data) => {
  setUser(data);
};

export const validateContactNo = (contactNo) => {
  if (!contactNo || typeof contactNo !== 'object') {
    return false;
  }
  const { areaCode, number } = contactNo;
  // Convert areaCode to string for consistent validation
  const areaCodeStr = String(areaCode || '');
  const numberStr = String(number || '');

  // Normalize areaCode - convert '1' to '+1' for consistent validation
  const normalizedAreaCode = areaCodeStr === '1' ? '+1' : areaCodeStr;

  // Check if both areaCode and number exist and are not empty
  // Handle both string and number types for areaCode and number
  const hasValidAreaCode =
    normalizedAreaCode &&
    normalizedAreaCode !== '' &&
    normalizedAreaCode !== 'null' &&
    normalizedAreaCode !== 'undefined';
  const hasValidNumber =
    numberStr &&
    numberStr !== '' &&
    numberStr !== 'null' &&
    numberStr !== 'undefined';

  // Additional validation for number format (should be 10 digits)
  const isValidNumberFormat = numberStr && /^\d{10}$/.test(numberStr);

  const result = hasValidAreaCode && hasValidNumber && isValidNumberFormat;
  console.log('🔍 DEBUG: validateContactNo final result:', result);

  return result;
};
